<template>
    <common-dialog
      ref="dialog"
      title="Add Instruction"
      :inputs-map="form"
      :save-cb="saveInstruction"
    >
    </common-dialog>
  </template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// models
import { BolInstructionForm } from '@/core/models/goods'

export default {
  name: 'AddBolInstruction',
  props: {},
  components: {
    CommonDialog
  },
  methods: {
    saveInstruction(info, done, error) {
      // todo 需要检查 输入的东西是否正确
      this.saveCb(info.instruction)
      this.$refs.dialog.close()
    },
    open(instruction, saveCb) {
      this.form[0].value = instruction
      this.saveCb = saveCb
      this.$refs.dialog.open()
    },
    reset() {
      this.form = cloneDeep(BolInstructionForm)
    }
  },
  data() {
    return {
      form: cloneDeep(BolInstructionForm),
      saveCb: null
    }
  }
}
</script>
  <style lang="scss" scoped>
  @import '@/assets/styles/common.scss';
  </style>
